import { useCallback, useState } from "react";

import { Grid, Box, IconButton, Tooltip, Typography } from "@material-ui/core";

import VisibilityIcon from "@material-ui/icons/Visibility";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import { sortableField, columnTextField } from "utils/tables-utils";
import IconButtonLoader from "components/Buttons/IconButtonLoader";
import MaskAndValid from "utils/maskAndValid";
import PrintButton from "components/_refactor/button/print";
import ReactExport from "react-export-excel";
import { IsMobile } from "../../../utils/is-mobile";

const exportIconStyle = {
  width: 25,
  height: 25,
  marginLeft: 15,
};

const getTableColumns = (setSelectedStore) => [
  columnTextField(
    {
      dataField: "CnpjLoja",
      text: "CNPJ",
      formatter: (data) => {
        return data ? MaskAndValid.maskCPNJCPF(data) : "";
      },
      csvFormatter: (data) => {
        return data ? MaskAndValid.maskCPNJCPF(data) : "";
      },
      align: "center",
    },
    true
  ),
  sortableField({
    dataField: "RazaoSocial",
    text: "Razão Social",
  }),
  sortableField({
    dataField: "Apelido",
    text: "Apelido",
  }),
  sortableField({
    dataField: "NomeComercial",
    text: "Nome Comercial",
  }),
  sortableField({
    dataField: "Cidade",
    text: "Cidade",
  }),
  sortableField({
    dataField: "UF",
    text: "UF",
    align: "center",
  }),
  {
    dataField: "editar",
    text: "",
    isDummyField: true,
    csvExport: false,
    headerStyle: { width: 45 },
    formatter: (cell, row) => {
      return (
        <Tooltip title="Visualizar Informações Complementares">
          <IconButton
            aria-label="edit"
            onClick={() => {
              setSelectedStore(row);
            }}
          >
            <Box
              component={VisibilityIcon}
              width="1.25rem!important"
              height="1.25rem!important"
            />
          </IconButton>
        </Tooltip>
      );
    },
  },
];

const TableInfosComplementares = ({
  dataTable,
  search,
  currentSizePerPage,
  currentPage,
  totalRegistros,
  setSelectedStore,
}) => {
  const [loading, setLoading] = useState(false);

  const isMobile = IsMobile();

  const doSearch = useCallback(async (page, sizePerPage) => {
    setLoading(true);

    await search({ page, sizePerPage });

    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageChange = useCallback(
    (page, sizePerPage) => {
      doSearch(page, sizePerPage);
    },
    [doSearch]
  );

  const handleSizePerPageChange = useCallback(
    (sizePerPage, page) => {
      doSearch(page, sizePerPage);
    },
    [doSearch]
  );

  const ExcelFile = ReactExport.ExcelFile;
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
  const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

  const ExportExcelIcon = () => {
    return (
      <Tooltip title="Exportar CSV da Página">
        <IconButtonLoader
          extraStyle={exportIconStyle}
          icon={
            <img
              src="https://img.icons8.com/material-outlined/72/000000/xls-export.png"
              alt="ícone clicável para exportar a tabela no formato Excel"
              style={exportIconStyle}
            />
          }
          size="small"
        />
      </Tooltip>
    );
  };

  const exportCmp = (
    <ExcelFile element={<ExportExcelIcon />} filename={"Pedidos"}>
      <ExcelSheet data={dataTable} name={"InformacoesComplementaresLojas"}>
        <ExcelColumn label="CNPJ" value="CnpjLoja" />
        <ExcelColumn label="Razão Social" value="RazaoSocial" />
        <ExcelColumn label="Apelido" value="Apelido" />
        <ExcelColumn label="Nome Comercial" value="NomeComercial" />
        <ExcelColumn label="Cidade" value="Cidade" />
        <ExcelColumn label="UF" value="UF" />
      </ExcelSheet>
    </ExcelFile>
  );

  return (
    <>
      <Grid item xs={12}>
        <ToolkitTable
          keyField="IdLoja"
          dataTable={dataTable}
          columnModel={getTableColumns(setSelectedStore)}
          csvFileName="InformacoesComplementaresLojas.csv"
          searched={Boolean(dataTable)}
          showPrint
          pagination={{
            options: [25, 50, 100],
            defaultOption: currentSizePerPage,
            totalSize: totalRegistros,
            showTotal: true,
            page: currentPage,
            onPageChange: handlePageChange,
            sizePerPage: currentSizePerPage,
            onSizePerPageChange: handleSizePerPageChange,
          }}
          loading={loading}
          bootstrapTableProps={{
            remote: true,
            onTableChange: () => {},
          }}
          notFoundTitle="Sua pesquisa não encontrou registros correspondentes."
          CustomHeader={({ componentRefProps, selectRefProps }) => (
            <Grid container className="pl-4" style={{ padding: "0 24px 12px" }}>
              <Grid
                item
                xs={isMobile ? 12 : 6}
                style={{ display: "flex", alignItems: "center" }}
              >
                <Box
                  component={Typography}
                  variant="h3"
                  marginBottom="0!important"
                >
                  <Box component="span">
                    Informações Complementares de Lojas
                  </Box>
                </Box>
              </Grid>
              <Grid
                item
                xs={isMobile ? 12 : 6}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: isMobile ? "flex-start" : "flex-end",
                  padding: 0,
                  marginBottom: "0.5rem!important",
                  marginTop: isMobile && "1rem",
                }}
              >
                <Box
                  justifyContent="flex-end"
                  alignItems="center"
                  display="flex"
                  flexWrap="wrap"
                  style={{
                    marginLeft: !isMobile && 15,
                    marginRight: 15,
                    cursor: "pointer",
                  }}
                >
                  {exportCmp}
                </Box>
                <Box
                  justifyContent="flex-end"
                  alignItems="center"
                  display="flex"
                  flexWrap="wrap"
                  style={{ marginLeft: 15, marginRight: 15, cursor: "pointer" }}
                >
                  <PrintButton
                    selectRef={selectRefProps}
                    componentRef={componentRefProps}
                    dataTable={dataTable}
                  />
                </Box>
              </Grid>
            </Grid>
          )}
        />
      </Grid>
    </>
  );
};

export default TableInfosComplementares;
